import { useState } from 'react';
import './Styles/post.css';
import LoadingAnimation from './LoadingAnimation';
import SearchForm from './Header/SearchForm';
import LoadedPost from './LoadedResponses/LoadedPost';
import styled from 'styled-components';
import { device } from './device';
import retangle from '../Media/Rectangle.png';

import ferramenta_baixar_foto_img1 from '../Media/ferramenta-baixar-foto-img1.jpeg';
import ferramenta_baixar_foto_img2 from '../Media/ferramenta-baixar-foto-img2.jpeg';
import ferramenta_baixar_foto_img3 from '../Media/ferramenta-baixar-foto-img3.jpeg';
import ferramenta_baixar_foto_img4 from '../Media/ferramenta-baixar-foto-img4.jpeg';
import ferramenta_baixar_foto_img5 from '../Media/ferramenta-baixar-foto-img5.jpeg';
import ferramenta_baixar_foto_img6 from '../Media/ferramenta-baixar-foto-img6.jpeg';
import ferramenta_baixar_foto_img7 from '../Media/ferramenta-baixar-foto-img7.jpeg';
import ferramenta_baixar_foto_img8 from '../Media/ferramenta-baixar-foto-img8.jpeg';
import ferramenta_baixar_foto_img9 from '../Media/ferramenta-baixar-foto-img9.jpeg';
import ferramenta_baixar_foto_img10 from '../Media/ferramenta-baixar-foto-img10.jpeg';

import Header from './Header/Header';
import { Helmet } from 'react-helmet';
import Margin from './Margin';
import { HeaderMenu } from './HeaderMenu';
import { Carousel } from 'react-responsive-carousel';
import { api } from '../server/api';
import { Tools } from './Tools';
import { Faq } from './Tools/Faq';

const Foto = (props) => {
  const [postUrl, setPostUrl] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [hasLoaded, setHasLoaded] = useState(false);
  const [newPostId, setPostId] = useState('');
  const [responseObj, setResponseObj] = useState();
  const items = [
    {
      question: 'É preciso informar algum de seus dados pessoais?',
      answer:
        'Não. Para usar nossa ferramenta de baixar foto Instagram, você não precisa informar nenhum de seus dados pessoais. Basta inserir o link da publicação em questão e a opção de download será disponibilizada no site.',
    },
    {
      question:
        'O proprietário do perfil vai saber que baixei o conteúdo dele?',
      answer:
        'Não. Para usar nossa ferramenta de baixar foto Instagram, você não precisa informar nenhum de seus dados pessoais. Basta inserir o link da publicação em questão e a opção de download será disponibilizada no site.',
    },
    {
      question:
        'É preciso instalar o ImpulsioneGram no telefone ou no computador para baixar foto do Instagram?',
      answer:
        'Não. Para usar nossa ferramenta de baixar foto Instagram, você não precisa informar nenhum de seus dados pessoais. Basta inserir o link da publicação em questão e a opção de download será disponibilizada no site.',
    },
  ];

  function getId(url) {
    if (url.split('/p/')[1]) {
      return url.split('/p/')[1].split(' ')[0].slice(0, 11);
    } else {
      alert('Válido somente posts do Instagram');
      return (
        <div className="error-page">
          <h2>Nenhuma foto encontrada!</h2>
          <p>Veja se você digitou o link corretamente.</p>
        </div>
      );
    }
  }

  function onChangehandler(e) {
    setPostUrl(e.target.value);
  }

  function submitHandler(e) {
    e.preventDefault();
    if (postUrl.length === 0) {
      alert('Empty Post link !');
      return;
    }
    setIsLoading(true);
    fetchPost();
  }

  async function fetchPost() {
    const postId = getId(postUrl);
    try {
      const { data } = await api.get(
        `foto/${postId}`,

        {
          headers: {
            token:
              'dcbbf9d1dd87939fdcf446d5fef2f8ec0ea4382cd4f51bc462211bf7ba83fd47',
          },
        },
      );

      console.log('🚀 ~ file: Video.jsx:76 ~ fetchPost ~ data:', data);
      setPostId(postId);
      setResponseObj(data);
      setIsLoading(false);
      setHasLoaded(true);
    } catch (error) {
      console.log('🚀 ~ file: Video.jsx:85 ~ fetchPost ~ error:', error);
    }
  }

  return (
    <>
      <Helmet>
        <title>Baixar Foto do Instagram Grátis Online e Rápido [2023]</title>
        <meta
          name="description"
          content="Baixe fotos do Instagram diretamente do telefone ou do PC. Somos o site mais completo de 2022 para baixar arquivos direto do Instagram em segundos ⭐️"
        ></meta>
      </Helmet>

      <Header />
      <div className="post-response">
        {isLoading && <LoadingAnimation />}
        {hasLoaded && (
          <LoadedPost responseObj={responseObj} postId={newPostId} />
        )}
      </div>
      <section id="post-section">
        <HeaderMenu
          submitHandler={submitHandler}
          onChangehandler={onChangehandler}
          placeholder="Digite o link do post"
          description={
            'Insira abaixo o LINK do vídeo escolhido e faça o download de forma online e gratuita.'
          }
          text_description={'BAIXE FOTOS DO INSTAGRAM'}
        />
      </section>

      <div className="background-white   py-5 color-grey-700">
        <div className="col-12 d-md-flex container">
          <div className="col-md-7 col-12">
            <div className="container text-left">
              <h1 className="text-center pb-5">
                Baixar Foto do Instagram Grátis Online e Rápido [2023]
              </h1>

              <p>
                Por mais que o Instagram tenha uma série de funcionalidades à
                disposição dos usuários, ainda faltam recursos que tornam sua
                experiência realmente completa, como{' '}
                <strong>baixar foto Instagram</strong>.
              </p>

              <p>
                Quando você está navegando pela{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/instagram-guia-completo/"
                  target="_blank"
                  rel="noreferrer"
                >
                  plataforma
                </a>
                , é comum que você se depare com alguma imagem bonita e queira
                salvá-la em seu dispositivo. Seja para ver novamente mais tarde,
                compartilhar com amigos(a) pelo aplicativo de{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/mensagem-automatica-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  mensagens
                </a>{' '}
                ou repostar no seu perfil da rede social.
              </p>

              <p>
                Para quem usa o Instagram para{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/instagram-shopping/"
                  target="_blank"
                  rel="noreferrer"
                >
                  vender
                </a>{' '}
                ou aumentar sua relevância, a exemplo de profissionais e
                empresas, salvar postagens de outros perfis se torna ainda mais
                importante.
              </p>

              <p>
                Isso porque, você pode usar técnicas de benchmarking para
                extrair{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/fotos-instagram-ideias/"
                  target="_blank"
                  rel="noreferrer"
                >
                  boas ideias
                </a>{' '}
                do conteúdo dos concorrentes, montando uma{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/divulgacao-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  estratégia poderosa
                </a>{' '}
                para o seu negócio superá-los.
              </p>

              <p>
                No entanto, o Instagram não tem nenhuma opção nativa que permite
                seus usuários salvarem imagens fora da rede social. Pelo menos
                por enquanto, só é possível baixar foto Instagram por meio de
                ferramentas de terceiros.
              </p>

              <p>
                Logo abaixo, vamos explicar{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/como-ser-verificado-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  passo a passo
                </a>{' '}
                como você pode fazer isso, tanto pelo PC como pelo smartphone,
                pela ferramenta do ImpulsioneGram. Para assim, não perder
                nenhuma{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/como-tirar-foto-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  foto valiosa
                </a>
                que encontrar na plataforma. Acompanhe!
              </p>

              <p>Boa leitura!</p>
            </div>
          </div>
          <div className="col-md-5 col-12">
            <img
              className=" img-fluid img-responsive"
              src={retangle}
              alt="publicação instagram ícone três pontos topo lateral direita"
              width={'auto'}
            />
          </div>
        </div>

        <div className="  background-gray">
          <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_foto_img1}
                    alt="feed Instagram ícone três pontos topo lateral direita"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_foto_img2}
                    alt="seta apontando para copiar link feed Instagram"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar foto Instagram pelo computador?
              </h2>

              <div className="text-left">
                <h4 className="pb-3">1. Copie o link da foto</h4>

                <p>
                  Para baixar foto Instagram por meio do computador, você
                  precisa, antes de mais nada, copiar o link da publicação da
                  foto em questão, acessando a versão desktop da rede social. Há
                  duas maneiras de copiar o link: barra de endereço e ícone de
                  três pontinhos.
                </p>

                <p>
                  Na primeira opção, você deve clicar sobre a barra de endereço
                  do site que fica na parte superior da tela do seu PC. Depois
                  disso, basta usar os seguintes atalhos: Ctrl+A e Ctrl+C.
                  Assim, o link será copiado para área de transferência.
                </p>

                <p>
                  Na segunda, você deve clicar sobre o ícone de três pontinhos
                  que fica no canto direito superior da publicação. Feito isso,
                  selecione “Copiar link” para deixá-lo na área de transferência
                  do computador.
                </p>

                <p>
                  Importante: em{' '}
                  <a
                    href="https://www.impulsionegram.com.br/blog/como-tirar-fotos-produtos-instagram/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    fotos do Instagram
                  </a>{' '}
                  Stories, somente o primeiro método vai funcionar, já que não
                  há uma opção “Copiar link” disponível, assim como no{' '}
                  <a
                    href="https://www.impulsionegram.com.br/blog/feed-instagram/"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Feed da rede social
                  </a>
                  , por exemplo.
                </p>

                <h4 className="pb-3">
                  2. Entre no site das ferramentas do ImpulsioneGram
                </h4>

                <p>
                  Copiado o link para baixar foto Instagram, o próximo passo
                  será entrar no site das ferramentas do ImpulsioneGram, que
                  pode ser acessado no topo dessa página.
                </p>
              </div>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">3. Selecione “Foto”</h4>

            <p>
              Na página inicial das ferramentas do ImpulsioneGram, note que há
              diversas opções disponíveis para você escolher livremente. Neste
              caso, porém, selecione “Foto” para continuar o processo de baixar
              foto Instagram.
            </p>

            <h4 className="pb-3">4. Cole o link da foto</h4>

            <p>
              O link copiado no primeiro passo deve ser colocado no campo
              “Digite o link do post”. É possível fazer isso usando o atalho
              Ctrl+V ou clicando com botão direito do mouse no campo e indo na
              opção “Colar”.
            </p>

            <h4 className="pb-3">5. Faça o download da foto</h4>

            <p>
              Colou o link no campo solicitado? Ótimo, agora falta pouco. Para
              baixar foto Instagram, clique em “Download”. Assim, a foto da
              publicação será carregada na página da ferramenta do
              ImpulsioneGram.
            </p>

            <p>
              Antes de fazer o download, você pode dar uma olhada para conferir
              se está tudo certo com a foto em questão. Feito isso, clique
              novamente em “Download”, só que dessa vez no botão que está abaixo
              da imagem.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! A foto vai começar a ser baixada no seu computador. Quando
              o processo for finalizado, normalmente o arquivo pode ser
              encontrado na pasta “Download” para você vê-la ou utilizá-la
              quando quiser.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_foto_img3}
                  alt="seta indicando ícone foto ferramenta ImpulsioneGram"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_foto_img4}
                  alt="caixa de escrita para digitar link do post"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_foto_img5}
                  alt="seta apontando botão de download com tela borrada"
                />
              </div>
            </Carousel>
          </div>
        </div>
        <div className="background-gray py-5">
          <div className="container col-12 d-md-flex justify-content-center align-items-center">
            <div className="col-md-5 col-12 pe-4">
              <Carousel
                emulateTouch={true}
                infiniteLoop={true}
                showStatus={false}
                showThumbs={false}
              >
                <div>
                  <img
                    className="image-bottom"
                    src={ferramenta_baixar_foto_img6}
                    alt="seta apontando três pontos publicação feed Instagram"
                  />
                </div>
                <div>
                  <img
                    className="image-bottom img-fluid img-responsive"
                    src={ferramenta_baixar_foto_img7}
                    alt="seta apontando para ícone de link em destaque"
                  />
                </div>
              </Carousel>
            </div>
            <div className="col-md-7 col-12">
              <h2 className="text-center py-4">
                Como baixar foto Instagram pelo smartphone?
              </h2>

              <h4 className="pb-3">1. Copie o link da foto</h4>

              <p>
                Assim como no processo de baixar foto Instagram pelo computador,
                no smartphone você precisa copiar o link da publicação em que a
                foto está primeiramente.
              </p>

              <p>
                Para isso, basta clicar no ícone com três pontinhos no canto
                superior direito da{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/tamanho-post-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  postagem
                </a>
                e selecionar a opção “Copiar link”. Esse processo funciona tanto
                no{' '}
                <a
                  href="https://www.impulsionegram.com.br/blog/perguntas-perfil-instagram/"
                  target="_blank"
                  rel="noreferrer"
                >
                  Stories
                </a>{' '}
                quanto no Feed.
              </p>

              <h4 className="pb-3">
                2. Entre no site das ferramentas do ImpulsioneGram
              </h4>

              <p>
                Em seguida, vá no site das ferramentas do ImpulsioneGram. Você
                pode acessar subindo essa página até o início no menu das
                ferramentas.
              </p>
            </div>
          </div>
        </div>
        <div className="container col-12 d-md-flex justify-content-center align-items-center py-5">
          <div className="col-md-7 col-12">
            <h4 className="pb-3">3. Selecione “Foto”</h4>

            <p>
              Chegando no site das ferramentas do ImpulsioneGram, haverá algumas
              opções disponíveis. Para baixar foto Instagram, você deve
              selecionar “Foto” para continuar.
            </p>

            <h4 className="pb-3">4. Cole o link da foto</h4>

            <p>
              Feito isso, é hora de colar o link da foto copiado no primeiro
              passo do processo para baixar foto Instagram no campo solicitado
              pelo site. Ou seja, aquele que está escrito “Digite o link do
              post”.
            </p>

            <p>
              Pressione seu dedo sobre o campo, por pelo menos dois segundos.
              Assim, vai aparecer na tela a opção “Colar” para que você inserir
              o link da foto que copiou anteriormente.
            </p>

            <h4 className="pb-3">5. Faça o download da foto</h4>

            <p>
              Para baixar foto Instagram, clique em “Download”. Dessa forma, a
              imagem será carregada dentro da página da ferramenta do
              ImpulsioneGram. Você pode visualizá-la para conferir se está tudo
              certo ou selecionar “Download” novamente para salvá-la no seu
              smarphone.
            </p>

            <h4 className="pb-3">6. Pronto!</h4>

            <p>
              Pronto! O download será iniciado. Quando terminado, o arquivo da
              foto baixada provalvelmente poderá ser encontrado na pasta
              “Download” do seu celular para você ver ou usar a qualquer
              momento.
            </p>
          </div>
          <div className="col-md-5 col-12 pe-4">
            <Carousel
              emulateTouch={true}
              infiniteLoop={true}
              showStatus={false}
              showThumbs={false}
            >
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_foto_img8}
                  alt="print tela celular com seta indicando para ícone de foto"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_foto_img9}
                  alt="area para digitar link do post em destaque"
                />
              </div>
              <div>
                <img
                  className="image-bottom img-fluid img-responsive"
                  src={ferramenta_baixar_foto_img10}
                  alt="botão de download em destaque com seta apontando"
                />
              </div>
            </Carousel>
          </div>
        </div>
      </div>
      <Tools name_tool={'foto'} />
      <div className="background-white">
        <Faq
          title={'DÚVIDAS COMUNS RELACIONADAS A BAIXAR FOTOS DO INSTAGRAM'}
          questions={items}
        />
      </div>
      <div className="container my-5 simple-download">
        <h3 className="mb-4">
          NUNCA FOI TÃO SIMPLES BAIXAR SUAS FOTOS FAVORITAS!
        </h3>
        <div className="col-md-9 col-12 m-auto">
          <p>
            Por fim, nunca foi tão simples salvar suas fotos favoritas
            encontradas na rede social em seu dispositivo do que com nossa
            ferramenta de <strong>baixar foto Instagram.</strong>
          </p>

          <p>
            Como vimos, é um processo sem complicação alguma. Diferentemente de
            outras soluções por aí, você não precisa instalar nada, nem fornecer
            nenhum de seus dados para nós.
          </p>
          <p>
            No ImpulsioneGram, tudo acontece de forma online e rápida,
            acompanhando o ritmo da sua rotina. Então, com poucos cliques, você
            pode salvar quantas imagens quiser.
          </p>

          <p>
            E ainda o uso da ferramenta é 100% gratuito. Isso mesmo, não te
            cobramos nenhum centavo pelos downloads feitos com nossa solução,
            facilitando ainda mais para você.
          </p>
          <p>
            Comece a usar o quanto antes a nossa ferramenta de baixar foto
            Instagram, que pode ser acessada no topo da página, e nunca mais
            perca uma foto especial que encontrar na plataforma, salvando-a no
            seu computador ou smartphone.
          </p>
        </div>
      </div>
    </>
  );
};

export default Foto;
